export const ru = {
    found: 'Найдено',
    of: 'из',
    selected: 'Выбрано'
};
